<template>
  <ol class="breadcrumb">
    <li><router-link :to="{name: 'StrategyIndex'}">UDL Strategy Index</router-link></li>
    <li>
      <template v-for="(subject, index) in subjects">
        <router-link :key="subject.value" :to="{name: 'BrowseStrategiesPage', query: { subject: subject.value }}">{{ subject.label }}</router-link><template v-if="index < subjects.length - 1">, </template>
      </template>
    </li>
    <li class="text-muted">{{ title }}</li>
  </ol>
</template>

<script>
import { strategyFiltersDataMixin } from '@/components/strategies/strategy_filters_util'

export default {
  name: 'StrategyBreadcrumbs',
  mixins: [strategyFiltersDataMixin],
  props: {
    title: {
      type: String,
      required: true
    },
    tags: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    subjects() {
      let subjects = []
      for (let subjectData of this.subjectOptions) {
        const hasSubjectValue = this.tags.indexOf(subjectData.value) > -1
        const hasSubjectLabel = this.tags.indexOf(subjectData.label) > -1
        if (hasSubjectValue || hasSubjectLabel) {
          subjects.push(subjectData)
        }
      }
      return subjects
    }
  }
}
</script>

<style>
</style>
